import { Image } from 'src/rest/types/Image'

export const indexes = {
  Article: 'article',
  Talent: 'talent',
  Page: 'page',
  Project: 'project',
  Engagement: 'engagement',
  Job: 'job',
} as const

type ObjectValues<T> = T[keyof T]

export type Indexes = ObjectValues<typeof indexes>

export type ResultItem = {
  indexUid: Indexes
  title?: string
  name?: string
  pageTitle?: string
  description?: string
  slug?: string
  hero?: {
    desktopImage?: Image
    mobileImage?: Image
  }
  createdAt: string
  updatedAt: string
}
